import util from '../util'

let base= window.$servicePath;
export default {

  //---------------------文件字
  /**
   * 保存文件字数据
   * @param data
   * @return
   */
  saveFileWord(params) {
    return util.ajax(`${base}/cheetah/service/s:oa:oa.srv.saveFileWord`,params)
  },
  /**
   * 删除文件字数据
   * @param data
   *  ids
   * @return
   */
  deleteFileWord(ids) {
    return util.ajax(`${base}/cheetah/service/s:oa:oa.srv.deleteFileWord`,ids)
  },
  /**
   * 获取文件字数据
   * @param data
   *   id
   * @return
   */
  getFileWord(id) {
    return util.ajax(`${base}/cheetah/service/s:oa:oa.srv.getFileWord`,id)
  },
  /**
   * 显示文件字列表
   * @param data
   *   code
   *   start
   *   limit
   * @return
   */
  listFileWord(params) {
    return util.ajax(`${base}/cheetah/service/s:oa:oa.srv.listFileWord`,params)
  },
  /**
   * 显示文件字列表树
   * @param data
   *   condition
   *   start
   *   limit
   * @return
   */
  listFileWordTree(params) {
    return util.ajax(`${base}/cheetah/service/s:oa:oa.srv.listFileWordTree`,params)
  },
  /**
   * 导出文件字
   * @param params
   * @returns {*}
   */
  exportFileWord(params){
    return util.downloadAttachment(`${base}/cheetah/service/s:oa:oa.srv.exportFileWord`,params)
  },

  //---------------------部门代字
  /**
   * 保存部门代字数据
   * @param data
   * @return
   */
  saveDeptWs(params) {
    return util.ajax(`${base}/cheetah/service/s:oa:oa.srv.saveDeptWs`,params)
  },
  /**
   * 删除部门代字数据
   * @param data
   *  ids
   * @return
   */
  deleteDeptWs(ids) {
    return util.ajax(`${base}/cheetah/service/s:oa:oa.srv.deleteDeptWs`,ids)
  },
  /**
   * 获取部门代字数据
   * @param data
   *   id
   * @return
   */
  getDeptWs(id) {
    return util.ajax(`${base}/cheetah/service/s:oa:oa.srv.getDeptWs`,id)
  },
  /**
   * 显示部门代字列表
   * @param params
   *   condition
   *   start
   *   limit
   * @return
   */
  listDeptWs(params) {
    return util.ajax(`${base}/cheetah/service/s:oa:oa.srv.listDeptWs`,params)
  },
  listMultiLevelDocTree(params){
    return util.ajax(`${base}/cheetah/service/s:oa:oa.srv.listMultiLevelDocTree`,params)
  },
  listMultiLevelDocData(params){
    return util.ajax(`${base}/cheetah/service/s:oa:oa.srv.listMultiLevelDocData`,params)
  },
}



// WEBPACK FOOTER //
// ./src/common/api/oa.js